import React, { useState } from "react";
import Modal_v2 from "./Modal_v2";
import { Form, message } from "antd";
import Select_v2 from "./Select_v2";
import TextArea from "antd/lib/input/TextArea";
import Button_v2 from "./Button_v2";
import _ from "lodash";
import { sendDriverNotification } from "../../api/NotificationApi";
import { alertMessage } from "../../common/Common";
import { renderAlertMessage } from "../../helpers/common";

const MessageDriver = ({ messageDriver, setMessageDriver, drivers, driverDetails }) => {


    const [values, setValues] = useState({
        driver_ids: driverDetails?.id ? [driverDetails.id] : [],
        message: '',
    })

    const handleChange = (key, val) => {
        setValues((prevState) => ({
            ...prevState,
            [key]: val,
        }))
    }

    const handleMessageSubmit = () => {
        const { driver_ids, message } = values;
        if (driver_ids && message) {
            sendDriverNotification({ driver_ids, message }).then((result) => {
                if (result.success) {
                    alertMessage(result.message, "success", 10);
                    setMessageDriver(false)
                } else {
                    renderAlertMessage(result.errors)
                }
            });
        }
    }

    const modalContent = () => {
        return (
            <Form colon={false} data-testid="message-modal">
                <Form.Item
                    label={'Driver'}
                    className="dropdown-field table-col"
                >
                    <Select_v2
                        data-testid="driver-dropdown"
                        mode="multiple"
                        options={drivers}
                        value={values.driver_ids}
                        onChange={(val) => handleChange('driver_ids', val)}
                        valueField="id"
                        labelField="employee_code"
                    />
                </Form.Item> <br />
                <Form.Item
                    // className="table-col custom-form-item"
                    label={'Message'}
                >
                    <TextArea
                        data-testid="message-input"
                        rows={4}
                        value={values.message}
                        onChange={(e) => handleChange('message', e.target.value)}
                    />
                </Form.Item>
            </Form>
        )
    }

    const modalFooter = () => {
        return (
            <div>
                <Button_v2
                    data-testid="cancel-message-button"
                    className="medium-btn flat"
                    text="Cancel"
                    onClick={() => {
                        setMessageDriver(false)
                    }}
                />
                <Button_v2
                    data-testid="save-message-button"
                    className="medium-btn raised"
                    disabled={(values.driver_ids.length == 0 || values.message == "")}
                    text="Send"
                    onClick={() => {
                        handleMessageSubmit()
                    }}
                />
            </div>
        )
    }
    return (
        <Modal_v2
            // className='message-driver-modal'
            visible={messageDriver}
            title={'Send Notification'}
            content={modalContent()}
            footer={modalFooter()}
            closable={false}
        />
    )
}

export default MessageDriver